<template>
  <div class="fts-module-form comfort-form-design">
    <div class="module-form-emoji-wrapper">
      <fts-emoji
        append-to-body
        :toggle-size="56"
        placement="bottom"
        class="module-form-emoji"
        v-model="formData.emoji"
      />
    </div>

    <div class="fts-form-group">
      <fts-form-label placement="top">Module Name</fts-form-label>
      <input
        class="fts-form-control"
        v-model="formData.name"
        @input="$v.formData.name.$touch()"
      />
      <div class="fts-form-error" v-if="$v.formData.name.$error">
        {{getModuleNameError()}}
      </div>

      <fts-contenteditable
        v-model="formData.description"
        placeholder="enter module description"
        text-wrap
        class="module-form-description"
      />
    </div>

    <div class="fts-form-group">
      <fts-form-label placement="top">User Profile</fts-form-label>
      <div class="fts-form-helper">
        Connects this module to users. Able to manage user access or permission through profile.
      </div>
      <fts-toggle-switch
        v-model="formData.isUserCollection"
        color="primary"
        mat-class
        :size="16"
      />
    </div>

    <div class="fts-form-group">
      <fts-form-label placement="top">Publish</fts-form-label>
      <div class="fts-form-helper">
        Set module to publish or unpublish.
      </div>
      <fts-toggle-switch
        v-model="formData.published"
        color="primary"
        mat-class
        :size="16"
      />
    </div>

    <div class="fts-form-group" v-if="automation && automation.length">
      <fts-form-label placement="top">Automations & Notifications</fts-form-label>
      <div class="fts-form-helper">
        Automation blocks, notification, reminder, or alert
      </div>
      <div class="module-form-event-container">
        <fts-event
          v-for="event in automation"
          :key="event.id"
          :event="event"
          @open="openAutomationDesignModal"
        />
      </div>
    </div>

    <div class="fts-form-group">
      <fts-form-label placement="top">Danger Zone</fts-form-label>
      <div class="fts-form-helper">
        Once you delete the module, there is no going back. Please be certain.
      </div>
      <fts-btn
        color="danger"
        outline
        text-transform-init
        @click="deleteModule"
      >
        Delete Module
      </fts-btn>
    </div>

    <div class="fts-text-right">
      <fts-btn
        text
        text-transform-init
        @click="cancel"
      >
        Cancel
      </fts-btn>
      <fts-btn
        color="primary"
        text-transform-init
        box-shadow-none
        :disabled="$v.formData.$invalid"
        @click="done"
      >
        Apply
      </fts-btn>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

import designValidator from '../commons/designValidator';

import FTSBtn from '../elements/FTSBtn';
import FTSContenteditable from '../elements/FTSContenteditable';
import FTSEmoji from '../elements/FTSEmoji';
import FTSFormLabel from '../elements/FTSFormLabel';
import FTSToggleSwitch from '../elements/FTSToggleSwitch';
import FTSEvent from '../design/event/FTSEvent.vue';

export default {
  props: {
    module: Object,
    modules: Array,
    automation: Array
  },
  components: {
    'fts-btn': FTSBtn,
    'fts-contenteditable': FTSContenteditable,
    'fts-emoji': FTSEmoji,
    'fts-form-label': FTSFormLabel,
    'fts-toggle-switch': FTSToggleSwitch,
    'fts-event': FTSEvent
  },
  data: () => ({
    formData: {}
  }),
  validations() {
    let formData = {};
    formData = designValidator.moduleDesign(this.modules);
    return { formData };
  },
  methods: {
    reset() {
      this.$v.$reset();
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    cancel() {
      this.$emit("cancel");
      this.reset();
    },
    done() {
      if (!this.$v.formData.$invalid) {
        this.$emit("module:update", this.formData);
        this.reset();
      }
    },
    setForm() {
      this.formData = _.cloneDeep(this.module);
    },
    getModuleNameError() {
      return designValidator.moduleDesignError(this.$v.formData, "name");
    },
    async deleteModule() {
      const res = await this.$confirmation.show({
        type: "delete",
        title: "Module",
        text: this.module.name,
        textEmoji: this.module.emoji,
        enableConfirmationKey: true
      });
      if (res === true) {
        this.$emit("module:delete", {
          id: this.module.id,
          name: this.module.name,
          emoji: this.module.emoji
        });
      }
    },
    openAutomationDesignModal(item) {
      this.$emit("automation:open", item);
    }
  },
  mounted() {
    this.setForm();
  }
}
</script>

<style lang="scss">
@use "./src/assets/scss/vars" as *;

.fts-module-form {
  .module-form-emoji-wrapper {
    margin-bottom: 1rem;
    text-align: center;
    .module-form-emoji {
      display: inline-flex;
    }
  }
  .module-form-description {
    margin-top: 1rem;
    font-size: 0.875rem;
    color: var(--fts-default);
  }
  .module-form-event-container {
    @include flex-gap($display: flex, $gap: 0.375rem);
  }
}
</style>